module.exports = __webpack_public_path__ + "img/icon_try-home.b4d64baf.png";